import * as React from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';

export interface IWebshopProductCard {
  productName: string;
  imageUrl: string;
  productShortInfo: string;
  urlPath: string;
  productSKU : string;
  variants : any[];
  onGotoProductDetailPage : (urlPath) => void;
}
export const WebshopProductCard = (props: IWebshopProductCard) => {
  
  const onGotoProductDetailPage = (event) => {
    event.preventDefault();
    if (props.onGotoProductDetailPage) {
      props.onGotoProductDetailPage(props.urlPath);
    }
    return false;
  };

  return (
    <Link to={props.urlPath} className="col-12 col-sm-6 col-md-4 col-lg-3 webshop-product-card">
      <div className="webshop-product-card__product-image">
        <img src={props.imageUrl} />
      </div>
      <h3 className="webshop-product-card__product-name">
        {props.productName}
      </h3>
      <div className="webshop-product-card__product-short-info">
        {ReactHtmlParser(props.productShortInfo)}
      </div>
      <button onClick={onGotoProductDetailPage} className="btn btn-success webshop-product-card__add-button">
        <span className="webshop-product-card__add-button-text">+</span>
        <span className="icon icon-shopping-cart"></span>
      </button>
    </Link>
  );
};
